module.exports = __webpack_public_path__ + "img/slide_2_comp_mob.a5352baa.jpg";